import './index.scss';
const lazy = require('public/lazyload');
const TestUa = require('func/ua');
// const Stat = require('public/stat');
// const Pullup = require('@ali/aliplay-pullup');
// 异步加载列表
require('public/ajax_hot_list')(function() {
  lazy.setInit();
}, { scrollLoad: true, initScroll: false });

require('public/weixin');

const Cards = require('../module/card/index');
const GameList = require('../module/game-list/index');
// const GameListRecommend = require('../module/game-list-recommend/index');
// const GameNews = require('../module/game-news/index');
const currentHotword = $('#currentHotword').val();
const AgStat = require('public/ag_statv2');
const ag_stat = new AgStat('hotword', {
  ag_field: 'hotword',
  ag_value: currentHotword,
});
class Module {
  constructor() {
    // 图片懒加载
    lazy.setInit();
    const xlyx = require('public/recommend');
    xlyx.callback = () => {
      // $('.game-download.count-download').attr('href', null).attr('btn', null).on('click', e => {
      //   const gameId = $(e.target).closest('.game-list-item.count-list-item').data('gameId');
      //   const urlCode = $('input[data-url-code]').data('urlCode');
      //   this.planABtestForDownload(gameId, `ugt-web-hotkeyword-xlyx-${urlCode}-${gameId}`);
      // });
    };
    this.renderInfo = {
      gameName: null,
      gameId: null,
      fileSize: null,
      instruction: null,
      logo: '',
      randomGameId: this.getRandom(6),
      randomPickId: this.getRandom(3),
    };
    this.insertDom();
    this.cardsData = this._cardsData;
    this.gameListData = this._gameListData;
    this.UnfoldLink();
    this.HeaderDetailToggleMore();
    this.DownloadPullUp();
    this.baiduChDownloadHandle();
    this.v21DownloadHandle();
    this.v22DownloadHandle();
    this.UnfoldCards();
    this.UnfoldGameList();
    this.ClickStat();
    this.FixMorePlayItem();
    // Stat.Stat({ action: 'page_view', from: 'hotwords' });
    const topicType = $('body').data('topictype');
    // Stat.StatPortal({ action: 'expose_topic_keywords', ag_a1: topicType });
    // 显示广告
    const Popover = require('public/popover');
    const popover = new Popover({
      container: '#show-popover', // 容器
      to: '.bottom-activity-icon', // 缩小的方向
      time: 3, // 显示多少s
      etag: 1 // 广告触发间隔期；单位默认1天； (测试需要可以修改单位为秒 etagType: 'second',etag: 3 )
    });
    popover.init();
  }
  get _gameListData() {
    const $cardsData = $('input[data-game-list-id]');
    const arr = [];
    $cardsData.forEach((e, index) => {
      const $e = $(e);
      if (!$e.data('gameListId')) return;
      const data = {};
      data.index = index;
      data.num = $e.data('index');
      data.gameListId = $e.data('gameListId');
      data.userName = $e.data('userName');
      data.userAbstract = $e.data('userAbstract');
      data.userLevel = $e.data('userLevel');
      data.userIcon = $e.data('userIcon');
      data.like = $e.data('like');
      data.abstract = $e.data('abstract');
      data.url = $e.data('url');
      data.img = $e.data('img');
      arr.push(data);
    });
    return arr;
  }

  get _cardsData() {
    const $cardsData = $('input[data-card-type]');
    const arr = [];
    $cardsData.forEach((e, index) => {
      const $e = $(e);
      if (!$e.data('cardType')) return;
      const data = {};
      data.index = index;
      data.num = $e.data('index');
      data.cardType = $e.data('cardType');
      data.adAbstract = $e.data('adAbstract');
      data.userName = $e.data('userName');
      data.userAbstract = $e.data('userAbstract');
      data.userLevel = $e.data('userLevel');
      data.userIcon = $e.data('userIcon');
      data.gameId = $e.data('gameId');
      data.gameName = $e.data('name');
      data.gameCategory = $e.data('category');
      data.gameSize = $e.data('size');
      data.gameScore = $e.data('score');
      data.gameAbstract = $e.data('abstract');
      data.gameUrl = $e.data('url');
      data.zoneHref = $e.data('zoneHref');
      data.gameIcon = $e.data('icon');
      data.gameDesc = $e.data('desc');
      data.operationstatus = $e.data('operationstatus');
      data.haspack = $e.data('haspack');
      data.gameKeywords = $e.data('keywords') ? $e.data('keywords').split(',') : [];
      data.gameImgs = $e.data('imgs') ? $e.data('imgs').split('|') : [];
      data.videoPlay = $e.data('videoPlay');
      data.gameCategoryUrl = $e.data('categoryUrl');
      data.gameKeywordsUrl = $e.data('keywordsUrls') ? $e.data('keywordsUrls').split(',') : [];
      arr.push(data);
    });
    return arr;
  }
  // 下载按钮拉起
  DownloadPullUp(ismore) {
    let $target = null;
    if (ismore === 1) {
      $target = $('.JS_ng_down[data-more="1"]');
    } else {
      $target = $('.JS_ng_down');
    }
    $target.on('click', e => {
      const gameId = $(e.target).data('gameId');
      const urlCode = $('input[data-url-code]').data('urlCode'); // 976611gameId
      this.PullUp(gameId, `ugt-web-hotkeyword-${urlCode}-${gameId}`);
    });
  }
  // 获取随机数
  getRandom(count) {
    let str = '';
    for (let i = 0; i < count; i++) {
      str += Math.floor(Math.random() * 10);
    }
    return str;
  }
  // 是否应该弹出第三方下载
  downloadThirdType(gameId, pullUpFrom) {
    const _this = this;
    $.ajax({
      type: 'GET',
      url: '//a.9game.cn/tpl/pc2/ajaxinfo/ajax_download_info.html',
      timeout: 4000,
      data: { gi: gameId, pi: 2 },
      success: (res) => {
        res = JSON.parse(res);
        if (res.toyBlockGameType === 1) { // 是积木游戏
          _this.doPullUp(gameId, pullUpFrom);
          return;
        }
        if (res.downloadThirdType === 1) {
          _this.getGameInfo(gameId);
        } else {
          this.planABtestForDownload(gameId, pullUpFrom);
          // _this.doPullUp(gameId, pullUpFrom);
        }
      },
      error: (err) => {
        console.log(err);
      }
    });
  }
  // 拉起封装
  PullUp(gameId, pullUpFrom) {
    this.downloadThirdType(gameId, pullUpFrom);
  }
  // 实现拉起
  doPullUp(gameId, pullUpFrom) {
    // Stat.StatHightSpeedDownload(gameId);
    const ch = $('input[data-url-code]').data('ch');
    var wakeUpUrlQuery  = $('#__WAKE_UP_URL_QUERY').val() || '';
    const params = {
      pageType: 'game_detail', // 需要拉起页面 pageType
      opt: 'download', // 拉起动作，可选
      gameId,
      ch,
      checkTime: 200,
      pullUpFrom, // 拉起来源
    }
    if (TestUa.isOppo()) { // oppo直接抛包
      var url = window.NineGameClientPullUp.getSchemeDownloadUrl(params)
      if (wakeUpUrlQuery) {
          if (url.indexOf('?') > -1) {
            url += (wakeUpUrlQuery ? '&' + wakeUpUrlQuery : '');
          } else {
            url += (wakeUpUrlQuery ? '?' + wakeUpUrlQuery  : '')
          }
      }
      console.log('d ===>', url);
      window.location.href = url;
      return
    } 
    NineGameClientPullUp.wakeup({ ...params, auto: false }, function(error, update, result) {
      if (!error) {
        console.log('拉起成功');
      } else {
        var url = result
        if (wakeUpUrlQuery) {
            if (url.indexOf('?') > -1) {
              url += (wakeUpUrlQuery ? '&' + wakeUpUrlQuery : '');
            } else {
              url += (wakeUpUrlQuery ? '?' + wakeUpUrlQuery  : '')
            }
        }
        console.log('d ===>', url);
        window.location.href = url;
        
      }
    });
  }
  // <-- 2018/12/06  A/B test 测试抛包（九游/游戏）效果 -->

  get isTestA() {
    const sid = $('[data-sid]').data('sid') || '';
    return !!(Number.parseInt(sid[ sid.length - 1 ], 16) % 2);
  }

  get isTestB() {
    const sid = $('[data-sid]').data('sid') || '';
    return !(Number.parseInt(sid[ sid.length - 1 ], 16) % 2);
  }


  planABtestForDownload(gameId, pullUpFrom) {
    this.pureGetGameInfo(gameId).then(e => {
      const { ppdownloanUrl } = JSON.parse(e);
      if (ppdownloanUrl) {
        window.location.href = ppdownloanUrl;
      } else {
        this.doPullUp(gameId, pullUpFrom);
      }
      // if (this.isTestA) {
      //   this.doPullUp(gameId, pullUpFrom, 'OK_1137');
      // } else {
      //   window.location.href = `${JSON.parse(e).downUrl}?ch=SO_41`;
      // }
    });
  }
  // !<--2018/12/06  A/B test 测试抛包（九游/游戏）效果 -->

  // 单纯的获取某个游戏的信息
  pureGetGameInfo(gameId) {
    // pp导量需求更新
    const topicId = $('[data-topicId]').data('topicid') || '';
    const promise = new Promise((resolve, reject) => {
      $.ajax({
        type: 'GET',
        url: '//a.9game.cn/tpl/android_new/common/gameinfo_ajax_pp.html',
        timeout: 4000,
        data: {
          gameId,
          topicId,
        },
        success: (res) => {
          resolve(res);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
    return promise;
  }

  // 获取某个游戏信息
  getGameInfo(gameid) {
    const _this = this;
    const topicId = $('[data-topicId]').data('topicid') || '';
    $.ajax({
      type: 'GET',
      url: '//a.9game.cn/tpl/android_new/common/gameinfo_ajax_pp.html',
      timeout: 4000,
      data: {
        gameId: gameid,
        topicId,
      },
      success: (res) => {
        res = JSON.parse(res);
        _this.renderInfo.gameId = res.gameId;
        this.renderInfo.randomGameId = this.getRandom(6);
        this.renderInfo.randomPickId = this.getRandom(3);
        $('.download-alert .gameinfo-wrap .game-name').text(res.gameName);
        $('.download-alert .content .game-name-span').text(res.gameName);
        const smallLogo = 'https://image.9game.cn' + res.logo;
        $('.download-alert .gameinfo-wrap .game-icon').attr('src', smallLogo);
        $('.download-alert .gameinfo-wrap .game-size').text(res.fileSize);
        $('.download-alert .gameinfo-wrap .game-pulisher-wrap').text(res.instruction);
        $('.download-game, .report').data('gameId', gameid);
        $('.download-alert').toggle(true);
        $('.download-game').data('ppDownloadurl', res.ppdownloanUrl);
        // Stat.Stat({ action: 'show_third_download', a1: 'third-download-type', a2: gameid });
      },
      error: (err) => {
        console.log(err);
      }
    });
  }
  // 插入第三方下载dom
  insertDom() {
    const _this = this;
    const html = ` <div class="download-alert" style="display:none">
                    <div class="download-container">
                      <div class="header">
                      <span class="title">第三方下载</span><img src="https://image.9game.cn/s/uae/g/0h/portal/image/download-close.png" alt="" class="download-close">
                      </div>
                      <div class="content">
                        <div class="tips">在dbcloud.top上搜索《<span class="game-name-span">${this.renderInfo.gameName}</span>》的结果</div>
                        <div class="address-wrap">
                        <input class="address" value="http://dbcloud.top/#/dl?game_id=${this.renderInfo.randomGameId}&pack_id=${this.renderInfo.randomPickId}">
                        </div>
                        <div class="gameinfo-wrap">
                          <img src="${this.renderInfo.logo}" alt="" class="game-icon">
                          <div class="game-detail">
                            <p class="game-name">${this.renderInfo.gameName}</p>
                            <p class="game-size">${this.renderInfo.fileSize}</p>
                            <p class="game-pulisher-wrap">${this.renderInfo.instruction}</p>
                          </div>
                          <div class="download-game">
                                下载
                          </div>
                        </div>
                        <div class="footer">
                        下载资源由第三方(目前为dpcloud.top)提供，若该资源违反当地规则或侵犯了你的合法权利，请及时<span class="report">举报</span>，我们会尽快和你联系并处理相关问题。
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="report-alert" style="display:none">
                    <div class="report-container">
                      <div class="header">
                        <span class="title">举报游戏</span><img src="https://image.9game.cn/s/uae/g/0h/portal/image/download-close.png" alt="" class="report-close">
                      </div>
                      <div class="content">
                        <div class="tips">若该资源违反当地规则或侵犯了你的合法权利，请举报，我们会尽快和你联系并处理相关问题。</div>
                        <div class="report-content-wrap">
                        <textarea class="report-content" placeholder="输入补充说明"></textarea>
                        </div>
                      </div>
                      <div class="footer">
                        <div class="report-cancal">取消</div>
                        <div class="report-comfire">确定</div>
                      </div>
                    </div>
                  </div>`;
    $('body').append(html);
    // 关闭第三方下载弹窗
    $('.download-close').on('click', function() {
      $('.download-alert').toggle(false);
    });
    // 点击举报
    $('.report').on('click', e => {
      $('.download-alert').toggle(false);
      $('.report-alert').toggle(true);
      const gameId = $(e.target).data('gameId');
      // Stat.Stat({ action: 'click_report', a1: 'third-download-type', a2: gameId });
    });
    // 关闭举报
    $('.report-cancal,.report-close,.report-comfire').on('click', function() {
      $('.download-alert').toggle(true);
      $('.report-alert').toggle(false);
    });
    $('.report-comfire').on('click', function() {
      $('.download-alert').toggle(true);
      $('.report-alert').toggle(false);
      $('.report-content').val('');
    });
    // 点击下载
    $('.download-game').on('click', e => {
      const gameId = $(e.target).data('gameId');
      // Stat.Stat({ action: 'click_download', a1: 'third-download-type', a2: gameId });
      const urlCode = $('input[data-url-code]').data('urlCode');
      const ppDownloadurl = $('.download-game').data('ppDownloadurl');
      if (ppDownloadurl) {
        window.location.href = ppDownloadurl;
      } else {
        this.doPullUp(gameId, `ugt-web-hotkeyword-${urlCode}-${gameId}`);
      }
    });
  }
  // 修复更多玩家在玩的ui不齐
  FixMorePlayItem() {
    let tempWidth = 0;
    const $root = $('.more-player-played');
    const $liMap = $root.find('li');
    const totalWidth = $root.find('ul').width();
    const widthMap = $root.find('li').map((index, e) => {
      return $(e).width() + 30;
    });
    widthMap.forEach((e, i) => {
      if (tempWidth + (e) > totalWidth) {
        if (totalWidth - tempWidth < 80) {
          tempWidth = e;
        } else {
          $liMap.eq(i).width(totalWidth - tempWidth);
          tempWidth = 0;
        }
      } else {
        tempWidth += (e);
      }
    });
  }
  // 广告位卡片展开更多
  UnfoldCards() {
    const that = this;
    $('.main-game-more').on('click', (e) => {
      const arr = this.cardsData.splice(0, 10);
      Cards.AppendCards(arr, function(html) {
        $(e.target).before(html);
        lazy.setInit();
        const xlyx = require('public/recommend');
        that.DownloadPullUp(1);
        that.baiduChDownloadHandle(1);
        that.v21DownloadHandle(1);
        that.v22DownloadHandle(1);
        xlyx.callback = () => {
          $('.game-download.count-download').attr('href', null).attr('btn', null).on('click', e => {
            const gameId = $(e.target).closest('.game-list-item.count-list-item').data('gameId');
            const urlCode = $('input[data-url-code]').data('urlCode');
            that.planABtestForDownload(gameId, `ugt-web-hotkeyword-xlyx-${urlCode}-${gameId}`);
          });
        };
      });
      if (this.cardsData.length === 0) {
        $(e.target).remove();
      }
    });
  }
  // 游戏单展开更多
  UnfoldGameList() {
    $('.game-list-more').on('click', (e) => {
      const arr = this.gameListData.splice(0, 4);
      GameList.AppendGameList(arr, function(html) {
        $(e.target).parent().find('.game-list-container').append(html);
        lazy.setInit();
      });
      if (this.gameListData.length === 0) {
        $(e.target).remove();
      }
    });
  }
  // 友链展开
  UnfoldLink() {
    $('.p-m-nav-friend-link .unfold-button').on('click', function() {
      $('.p-m-nav-friend-link .friend-link').addClass('unfold-friend-link');
      $('.p-m-nav-friend-link .unfold-button').addClass('hide-unfold-button');
    });
  }
  // 导图推荐文字展开
  HeaderDetailToggleMore() {
    const HeaderDetail = $('.header-detail');
    const toggle = $('<div class="detail-more">展开</div>');
    const toggleText = HeaderDetail.text();
    if (!HeaderDetail.data('content')) return;
    HeaderDetail.append(toggle);
    toggle.on('click', (e) => {
      $(e.target).text((index, old) => {
        if (old === '展开') {
          HeaderDetail.text(HeaderDetail.data('content'));
          HeaderDetail.append(toggle);
          return '收起';
        } else {
          HeaderDetail.text(toggleText);
          HeaderDetail.append(toggle);
          return '展开';
        }
      });
    });
  }

  ClickStat() {
    $('body').on('click', (e) => {
      if ($(e.target).hasClass('download')) {
        // Stat.Stat({ action: 'page_click', from: 'hotwords', target: 'game_download' });
        return;
      }
      const target = $(e.target).attr('class') || $(e.target).text() || $(e.target).parent().attr('class');
      // Stat.Stat({ action: 'page_click', from: 'hotwords', target });
    }, true);
  }

  // 针对百度渠道SO_1、JY_123、JY_3的有游戏包特殊下载
  baiduChDownloadHandle(ismore) {
    const that = this;
    let $downTarget = null;
    let $toggleTarget = null;
    if (ismore === 1) {
      $downTarget = $('.JS_bd_down[data-more="1"]');
      $toggleTarget = $('.JS_bd_toggle[data-more="1"]');
    } else {
      $downTarget = $('.JS_bd_down');
      $toggleTarget = $('.JS_bd_toggle');
    }
    $downTarget.on('click', function(e) {
      const ishigh = parseInt($(this).data('ishigh'), 10);
      if (ishigh === 1) {
        const gameId = $(this).data('gameId');
        const urlCode = $('input[data-url-code]').data('urlCode'); // 976611gameId
        that.PullUp(gameId, `ugt-web-hotkeyword-${urlCode}-${gameId}`);
      } else {
        const url = $(this).data('url');
        if (url.indexOf('http') === -1) {
          window.location.href = 'https://a.9game.cn' + url;
        } else {
          window.location.href = url;
        }
      }
    });

    $toggleTarget.on('click', function(e) {
      const $selbtn = $(this).find('.select-btn');
      $selbtn.toggleClass('select');
      if ($selbtn.hasClass('select')) {
        $(this).parent().find('.JS_bd_down').removeClass('hide');
        $(this).parent().find('.JS_REALNAME_DOWNLOAD').addClass('hide');
      } else {
        $(this).parent().find('.JS_bd_down').addClass('hide');
        $(this).parent().find('.JS_REALNAME_DOWNLOAD').removeClass('hide');
      }
    });
  }

  v21DownloadHandle(ismore) {
    const that = this;
    let $downTarget = null;
    let $toggleTarget = null;
    if (ismore === 1) {
      $downTarget = $('.JS_v21_down[data-more="1"]');
      $toggleTarget = $('.JS_v21_toggle[data-more="1"]');
    } else {
      $downTarget = $('.JS_v21_down');
      $toggleTarget = $('.JS_v21_toggle');
    }
    $downTarget.on('click', function(e) {
      const ishigh = parseInt($(this).data('ishigh'), 10);
      if (ishigh === 1) {
        const gameId = $(this).data('gameId');
        const urlCode = $('input[data-url-code]').data('urlCode');
        that.PullUp(gameId, `ugt-web-hotkeyword-${urlCode}-${gameId}`);
      } else {
        const url = $(this).data('url');
        if (url.indexOf('http') === -1) {
          window.location.href = 'https://a.9game.cn' + url;
        } else {
          window.location.href = url;
        }
      }
    });

    $toggleTarget.on('click', function(e) {
      const $selbtn = $(this).find('.select-btn');
      $selbtn.toggleClass('select');
      $(this).find('.text').toggleClass('select');
      if ($selbtn.hasClass('select')) {
        const btnTxt = $(this).parent().find('.txt').data('htxt');
        $(this).parent().find('.JS_v21_down').data('ishigh', '1').removeClass('normal');
        $(this).parent().find('.txt').text(btnTxt);
        $(this).parent().find('.JS_ani').show();
      } else {
        const btnTxt = $(this).parent().find('.txt').data('ntxt');
        $(this).parent().find('.JS_v21_down').data('ishigh', '0').addClass('normal');
        $(this).parent().find('.txt').text(btnTxt);
        $(this).parent().find('.JS_ani').hide();
      }
    });
  }

  v22DownloadHandle(ismore) {
    const that = this;
    let $downTarget = null;
    let $toggleTarget = null;
    if (ismore === 1) {
      $downTarget = $('.JS_v22_down[data-more="1"]');
      $toggleTarget = $('.JS_v22_toggle[data-more="1"]');
    } else {
      $downTarget = $('.JS_v22_down');
      $toggleTarget = $('.JS_v22_toggle');
    }
    $downTarget.on('click', function(e) {
      const ishigh = parseInt($(this).data('ishigh'), 10);
      if (ishigh === 1) {
        const gameId = $(this).data('gameId');
        const urlCode = $('input[data-url-code]').data('urlCode');
        that.PullUp(gameId, `ugt-web-hotkeyword-${urlCode}-${gameId}`);
      } else {
        const url = $(this).data('url');
        if (url.indexOf('http') === -1) {
          window.location.href = 'https://a.9game.cn' + url;
        } else {
          window.location.href = url;
        }
      }
    });

    $toggleTarget.on('click', function(e) {
      const $selbtn = $(this).find('.select-btn');
      $selbtn.toggleClass('select');
      if ($selbtn.hasClass('select')) {
        const btnTxt = $(this).parent().find('.JS_v22_down').data('htxt');
        const tipsTxt = $(this).find('.text').data('htxt');
        $(this).parent().find('.JS_v22_down').data('ishigh', '1').text(btnTxt).removeClass('normal');
        $(this).find('.text').text(tipsTxt);
        $(this).parents('.v22_mgameitem').find('.game-gifts').addClass('o').removeClass('g');
      } else {
        const btnTxt = $(this).parent().find('.JS_v22_down').data('ntxt');
        const tipsTxt = $(this).find('.text').data('ntxt');
        $(this).parent().find('.JS_v22_down').data('ishigh', '0').text(btnTxt).addClass('normal');
        $(this).find('.text').text(tipsTxt);
        $(this).parents('.v22_mgameitem').find('.game-gifts').addClass('g').removeClass('o');
      }
    });
  }
}

new Module();



// WEBPACK FOOTER //
// ./jws/views/page/hotwords/index/index.js